import { useState } from "react";
import { PLAN_PRICES } from "@/components/PricingTable";

const RATE = 0.3;
const PLANS = ["starter", "voice", "autopilot"];

const T = {
  ru: { label: "КАЛЬКУЛЯТОР ДОХОДА", title: "Сколько вы заработаете", desc: "Передвиньте ползунок и выберите тариф, на котором будут ваши клиенты. Комиссия — 30% с каждого платежа, пока клиент платит.", salons: "Привели салонов", plan: "Тариф клиентов", perMonth: "в месяц", mo: "мес", perYear: "в год", perSalon: "за салон в месяц", names: { starter: "Starter", voice: "Voice", autopilot: "Autopilot" } },
  en: { label: "INCOME CALCULATOR", title: "How much you'll earn", desc: "Move the slider and pick the plan your clients will be on. Commission is 30% of every payment, for as long as the client stays.", salons: "Salons referred", plan: "Clients' plan", perMonth: "per month", mo: "mo", perYear: "per year", perSalon: "per salon per month", names: { starter: "Starter", voice: "Voice", autopilot: "Autopilot" } },
  fr: { label: "CALCULATEUR DE REVENUS", title: "Combien vous gagnerez", desc: "Déplacez le curseur et choisissez le tarif de vos clients. Commission : 30 % de chaque paiement, tant que le client reste.", salons: "Salons parrainés", plan: "Tarif des clients", perMonth: "par mois", mo: "mois", perYear: "par an", perSalon: "par salon et par mois", names: { starter: "Starter", voice: "Voice", autopilot: "Autopilot" } },
  tr: { label: "GELİR HESAPLAYICI", title: "Ne kadar kazanırsınız", desc: "Kaydırıcıyı hareket ettirin ve müşterilerinizin tarifesini seçin. Komisyon: müşteri ödedikçe her ödemeden %30.", salons: "Getirilen salon", plan: "Müşteri tarifesi", perMonth: "aylık", mo: "ay", perYear: "yıllık", perSalon: "salon başına aylık", names: { starter: "Starter", voice: "Voice", autopilot: "Autopilot" } },
};

export default function PartnerCalculator({ lang = "en" }) {
  const L = T[lang] || T.en;
  const [n, setN] = useState(10);
  const [plan, setPlan] = useState("voice");
  const perSalon = Math.round(PLAN_PRICES[plan] * RATE * 10) / 10;
  const monthly = Math.round(n * PLAN_PRICES[plan] * RATE);

  return (
    <section className="max-w-6xl mx-auto px-6 pb-20" data-testid="partner-calc">
      <div className="bg-zinc-950 border border-zinc-800 rounded-2xl p-8 lg:p-10 grid lg:grid-cols-[1fr_1fr] gap-10 items-center">
        <div>
          <div className="text-xs font-medium tracking-wide text-yellow-300">{L.label}</div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mt-2">{L.title}</h2>
          <p className="mt-4 text-zinc-400 leading-relaxed max-w-md">{L.desc}</p>
          <div className="mt-8 flex items-center justify-between text-sm font-medium">
            <span className="text-zinc-300">{L.salons}</span>
            <span className="text-xl font-bold text-yellow-300" data-testid="partner-calc-count">{n}</span>
          </div>
          <input type="range" min={1} max={100} value={n} onChange={(e) => setN(Number(e.target.value))}
            data-testid="partner-calc-slider" className="w-full mt-2 accent-yellow-300 cursor-pointer" />
          <div className="mt-6 text-sm font-medium text-zinc-300">{L.plan}</div>
          <div className="mt-2 grid grid-cols-3 gap-2">
            {PLANS.map((k) => (
              <button key={k} onClick={() => setPlan(k)} data-testid={`partner-calc-plan-${k}`}
                className={`rounded-xl border px-2 py-2.5 text-sm font-semibold transition-colors ${plan === k ? "bg-yellow-300 border-yellow-300 text-black" : "bg-zinc-900 border-zinc-800 text-white hover:border-zinc-600"}`}>
                <div>{L.names[k]}</div>
                <div className={`text-[11px] font-medium ${plan === k ? "text-black/70" : "text-zinc-500"}`}>€{PLAN_PRICES[k]}/{L.mo}</div>
              </button>
            ))}
          </div>
        </div>
        <div className="bg-black/60 border border-yellow-400/20 rounded-2xl p-8 text-center">
          <div className="text-xs uppercase tracking-wide text-zinc-500">{L.perMonth}</div>
          <div className="text-5xl sm:text-6xl font-bold text-yellow-300 mt-2 leading-none" data-testid="partner-calc-monthly">€{monthly}</div>
          <div className="mt-6 grid grid-cols-2 gap-3 text-sm">
            <div className="bg-zinc-900 rounded-lg p-3">
              <div className="text-zinc-500 text-xs">{L.perYear}</div>
              <div className="font-semibold mt-1" data-testid="partner-calc-yearly">€{monthly * 12}</div>
            </div>
            <div className="bg-zinc-900 rounded-lg p-3">
              <div className="text-zinc-500 text-xs">{L.perSalon}</div>
              <div className="font-semibold mt-1">€{perSalon}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
